import { addDays } from "date-fns";

////////////////////////////////
//         INTERFACE          //
////////////////////////////////

/**
* Interface to have no-working days
*/
export interface DisabledDate {
  Disabled: Date[];
}

////////////////////////////////
//         FUNCTIONS          //
////////////////////////////////

/**
*Calculate the Easter date (algorithme de Meeus/Jones/Butcher)
*/
function getEasterDate(year: number): Date {
  const f = Math.floor,
    G = year % 19,
    C = f(year / 100),
    H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
    I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
    J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
    L = I - J,
    month = 3 + f((L + 40) / 44),
    day = L + 28 - 31 * f(month / 4);
  return new Date(year, month - 1, day);
}

/** 
*  Holidays in France
*/
function getFrenchHolidays(year: number): Date[] {
  const easter = getEasterDate(year);
  return [
    new Date(year, 0, 1), // Jour de l'an
    new Date(year, 4, 1), // Fête du travail
    new Date(year, 4, 8), // Victoire 1945
    new Date(year, 6, 14), // Fête nationale
    new Date(year, 7, 15), // Assomption
    new Date(year, 10, 1), // Toussaint
    new Date(year, 10, 11), // Armistice
    new Date(year, 11, 25), // Noël
    addDays(easter, 1), // Lundi de Pâques
    addDays(easter, 39), // Ascension
    addDays(easter, 50), // Lundi de Pentecôte
  ];
}

/** 
* Calculate Every weekend
*/
function getWeekends(year: number): Date[] {
  const weekends: Date[] = [];
  const date = new Date(year, 0, 1);
  while (date.getFullYear() === year) {
    if (date.getDay() === 0 || date.getDay() === 6) {
      // sunday=0, saturday=6
      weekends.push(new Date(date)); 
    }
    date.setDate(date.getDate() + 1);
  }
  return weekends;
}

/** 
* Generates the DisabledDate object for a given year
*/
export function getDisabledDates(year: number): DisabledDate {
  const holidays = getFrenchHolidays(year);
  const weekends = getWeekends(year);

////////////////////////////////
//         CONSTANTS          //
////////////////////////////////

/**  
* Combine and remove duplicates (in case a holiday falls on a weekend)
*/  
const allBlocked = [...holidays, ...weekends];

/** 
*  Delete duplicates
*/
  const uniqueBlockedMap = new Map<string, Date>();
  allBlocked.forEach((date) => {
    uniqueBlockedMap.set(date.toDateString(), date);
  });

  const uniqueBlocked = Array.from(uniqueBlockedMap.values());

  return { Disabled: uniqueBlocked };
}
